import React from 'react';
import { invalid, type } from "./common";
import { wrap } from './promise';

// document.getElementById('demo').onclick = function() {
//   if (document.documentElement.getBoundingClientRect) {
//     alert("left:" + this.getBoundingClientRect().left);
//     alert("top:" + this.getBoundingClientRect().top);
//     alert("right:" + this.getBoundingClientRect().right);
//     alert("bottom:" + this.getBoundingClientRect().bottom);
//     let X = this.getBoundingClientRect().left + document.documentElement.scrollLeft;
//     let Y = this.getBoundingClientRect().top + document.documentElement.scrollTop;
//     alert("Demo的位置是X:" + X + ";Y:" + Y)
//   }
// }

export function getBoundingClientRect(o) {
  return o.getBoundingClientRect();
}

export function textContent(o) {
  if (invalid(o)) return '';
  return React.Children.map(o, function (child) {
    if (type(child) === "string") return child;
    if (!child || !child.props) return '';
    let c = child.props ? (child.props.children || child.children) : child.children;
    if (c) return textContent(c);
    return '';
    // let obj = findDomNode(child);  不知道为什么，报错
    // return obj.innerText || obj.textContent;
  }).join('');
}



function _getImageSize(url, callback, fail) {
  let img = new window.Image();
  img.onload = function () {
    callback(img.width, img.height, img);
    img.onload = null;
  };

  img.onerror = (e) => {
    fail(new Error("获得图片大小出错"));
  }
  img.src = url;
};

export const getImageSize = (src) => {
  return wrap((resolve, reject) => {
    _getImageSize(src, (width, height) => {
      resolve({ width, height });
    }, reject);
  });

}

export const getImagesSize = (srcs) => {
  return Promise.all(srcs.map((src) => getImageSize(src)));
}

export const getBodyRect = () => {
  return {
    width: document.body.scrollWidth,
    height: document.body.scrollHeight
  }
}


export function addResizeListener(element, func) {  //添加窗口大小改变的侦听

  const observer = new ResizeObserver(_.debounce(entries => {
    if (func) func();
  }, 200));

  observer.observe(element);

  return () => {
    observer.unobserve(element);
  }
}

export function addWindowResizeListener(func) {  //添加窗口大小改变的侦听

  const onResize = _.debounce((e) => {
    if (func) func();
  }, 200);

  window.addEventListener("resize", onResize);

  return () => {
    window.removeEventListener("resize", onResize);
  }
}